export const NEGOTIATION_UNIT_PERCENTAGE = 'percentage'
export const NEGOTIATION_UNIT_CURRENCY = 'currency'
const NEGOTIATION_PRICE_MAX_DECIMALS = 5
const ERRORS = 'ctx.offers.variantOfferForm.negotiation.errors'

type NegotiationValue = string | number | null | undefined

interface NegotiationFields {
  negotiationPriceDecrease?: NegotiationValue
  negotiationPriceIncrease?: NegotiationValue
  negotiationUnit?: string | null
  measureUnitPrice?: NegotiationValue
}

type LimitField = 'negotiationPriceDecrease' | 'negotiationPriceIncrease'
export type NegotiationErrors = Partial<Record<LimitField | 'negotiationUnit', string[]>>

const isEmptyValue = (value: NegotiationValue): value is '' | null | undefined =>
  value === undefined || value === null || value === ''

function validateLimitFormat(value: number): string | undefined {
  if (Number.isNaN(value)) return `${ERRORS}.invalidNumber`
  if (+value.toFixed(NEGOTIATION_PRICE_MAX_DECIMALS) !== value) return `${ERRORS}.maxDecimals`
  if (value < 0) return `${ERRORS}.negative`
  return undefined
}

function validateLimitBoundary(value: number, unit: NegotiationFields['negotiationUnit'], price?: number) {
  if (unit === NEGOTIATION_UNIT_PERCENTAGE && value > 100) return `${ERRORS}.percentageExceeds100`
  if (unit === NEGOTIATION_UNIT_CURRENCY && price !== undefined && value > price)
    return `${ERRORS}.currencyExceedsPrice`
  return undefined
}

export function validateNegotiation(fields: NegotiationFields): NegotiationErrors {
  const limitFields: LimitField[] = ['negotiationPriceDecrease', 'negotiationPriceIncrease']
  if (limitFields.every((field) => isEmptyValue(fields[field]))) return {}

  const errors: NegotiationErrors = {}
  const price = isEmptyValue(fields.measureUnitPrice) ? undefined : +fields.measureUnitPrice

  limitFields.forEach((field) => {
    if (isEmptyValue(fields[field])) {
      errors[field] = [`${ERRORS}.required`]
      return
    }

    const value = Number(fields[field])
    const error = validateLimitFormat(value) || validateLimitBoundary(value, fields.negotiationUnit, price)
    if (error) errors[field] = [error]
  })

  if (!fields.negotiationUnit) errors.negotiationUnit = [`${ERRORS}.required`]

  return errors
}
